<template>
  <section class="section">
    <div class="content" v-if="loadingCertificate">
      <h1>Solicitar constancia de estudio</h1>
      <p>
        <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        Verificando estatus...
      </p>
    </div>
    <div class="content" v-else>
      <h1>Solicitar constancia de estudio</h1>
      <message-system size="small"></message-system>
      <div v-if="noDni">
        <form @submit.prevent="updateDNI">
        Aún no tiene registrado su DNI
          <div class="field proof-field">
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Ingrese su DNI"
                v-model="dni"
                required />
            </div>
            <div class="field proof-field">
              <div class="control">
                <button
                class="button button-certificate is-linkedin proof-button"
                :disabled="loadingDNI"
                type="submit">
                  <span v-if="loadingDNI">
                    <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    Guardando...
                  </span>
                  <span v-else>
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    Guardar
                  </span>
                </button>
              </div>
            </div>
            <small class="help is-danger">*Está operación solo se podrá hacer una vez</small>
          </div>
        </form>
      </div>
      <div v-else>
        <p v-if="isStudent">
          Si eres estudiante de algún curso, puedes solicitar tu constancia de estudio.
        </p>
        <p v-else>
          Lo sentimos, Usted no es estudiante en ningún curso en este momento.
        </p>
        <p>
            <a
              class="button button-certificate is-linkedin proof-button"
              @click.prevent="goToCertificate"
              :disabled="!isStudent">
              <span class="icon">
                <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
              </span>
              <span>Descargar</span>
            </a>
          </p>
      </div>
    </div>
  </section>
</template>
<script>
import EventBus from '@/helpers/event-bus'
export default {
  name: 'Proof',
  data () {
    return {
      certificate: null,
      dni: null,
      noDni: false,
      isStudent: false,
      loadingDNI: false,
      loadingCertificate: true
    }
  },
  methods: {
    async getCertificate () {
      const vm = this
      try {
        vm.loadingCertificate = true
        const response = await vm.$http.get(
          'users/proof/'
        )

        const { data } = response
        if (data.status === 'error') {
          if (data.message === 'No posee un DNI registrado') {
            vm.noDni = true
            vm.loadingCertificate = false
            return
          }

          if (data.message === 'Usted no es estudiante en ningún curso') {
            vm.isStudent = false
            vm.loadingCertificate = false
            return
          }
        }

        vm.noDni = false
        vm.isStudent = true

        vm.loadingCertificate = false
        vm.certificate = data.url
      } catch (error) {
        console.log('error', error)
      }
    },
    async updateDNI () {
      const vm = this
      vm.loadingDNI = true
      try {
        const response = await vm.$http.post(
          'users/dni/',
          {
            dni: vm.dni
          }
        )

        const { data } = response
        if (data.status === 'error') {
          EventBus.$emit('errorMessage', data.message)
          vm.loadingDNI = false
          return
        }

        EventBus.$emit('successMessage', 'DNI guardado correctamente')

        vm.loadingDNI = false
        vm.getCertificate()
      } catch (error) {
        console.log('error', error)
        EventBus.$emit('errorMessage', 'Ha ocurrido un error contacte a soporte')
      }
    },
    goToCertificate () {
      window.open(this.certificate, '_blank')
    }
  },
  mounted () {
    this.getCertificate()
  }
}
</script>
<style>
.proof-button {
  height: 3.5rem;
  width: 10rem;
}

.proof-button i {
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

.proof-button[disabled], .proof-button[disabled]:hover {
  background-color: #0E76A8;
  opacity: 0.5;
}

.proof-field {
  margin-top: 0.8rem;
  max-width: 12rem;
}
</style>



// WEBPACK FOOTER //
// proof.vue?23b264c2